<template>
    <div class="container">
      <div class="row pt-5">
        <div class="col-12 pt-5 d-flex justify-content-center">
            <div class="card text-white bg-convergenze mb-3 w-50">
                <div class="card-header">
                    <img src="../assets/Logo_bianco.svg" width="250px">
                </div>
                <div class="card-body">
                    <h5 class="card-title"><h4>Login Chat Operatore</h4></h5>
                    <div class="row">
                        <div class="col-12">
                            
                            <div class="row form-group">
                                <div class="col-12">
                                    <label>Username</label>
                                    <input type="text" v-model="username" class="form-control" />
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-12">
                                    <label>Password</label>
                                    <input type="password" v-model="password" class="form-control" />
                                </div>
                                <div class="col-3"></div>
                            </div>
                            <div class="row form-group">
                                <div class="col-4"></div>
                                <div class="col-4">
                                    <button class="btn btn-light" @click="onClickLogin">Login</button>
                                </div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      </div>
    </div>
</template>

<script>

import BackendApi from '../models/BackendApi'

export default {
    name: 'Login',
    data: function() {
        return {
                username: "",
                password: ""
        };
    },
    components: {    
    },
    computed: {       
    },
    methods: { 
        onClickLogin: function() {
            
            let api = new BackendApi(this.configApp)
            api.login(this.username,this.password,"","", (result) => {
                    if(result.isLogged == true){
                        localStorage.setItem("userLogged", JSON.stringify(result));
                        this.$router.push('/area-operatore')
                    } else{
                        alert("Username o password errati!")
                    }
            })
            //this.client.open()
        },
    },
    created: function() {
        let sessionId = this.$route.query.sessionId
        
        if(sessionId != undefined && sessionId.length > 0)
        {
            let api = new BackendApi(this.configApp)
            api.login("","",sessionId,"", (result) => {
                    if(result.isLogged == true){
                        localStorage.setItem("userLogged", JSON.stringify(result));
                        this.$router.push('/area-operatore')
                    } else{
                        alert("Impossibile eseguire l'autologin!")
                    }
            })
        }
    }
}

</script>